import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import Avatar from '../Avatar';
import HeaderMenuButton from './components/HeaderMenuButton';
import HeaderMenuNav from './components/HeaderMenuNav';
import HeaderSearch from '../../containers/HeaderSearch';

import { hideAboveSM, hideBelowMD } from '../../base-styles/mixins.module.css';
import { button, hiddenNav, mask, search, transparentSearch, visibleNav } from './styles.module.css';

/**
 * Header menu presentational component.
 */
const HeaderMenu = ({
  className,
  loggedIn,
  navId,
  navVisible,
  onButtonClick,
  onMaskClick,
  onNavCloseClick,
  onNavLinkClick,
  onSearchLinkClick,
  onSearchCloseClick,
  profile,
  searchVisible,
  transparent,
}) => (
  <div className={className}>
    {searchVisible &&
      <div>
        <HeaderSearch
          key="SM"
          className={hideAboveSM}
          onSearchCloseClick={onSearchCloseClick}
          searchVisible={searchVisible}
          mobile
        />
        <HeaderSearch
          key="MD/LG"
          className={hideBelowMD}
          onSearchCloseClick={onSearchCloseClick}
          searchVisible={searchVisible}
        />
      </div>}
    {navVisible && <button type="button" className={mask} onClick={onMaskClick} />}
    <HeaderMenuButton
      className={button}
      navId={navId}
      navVisible={navVisible}
      onClick={onButtonClick}
      transparent={transparent}
    />
    <HeaderMenuNav
      className={navVisible ? visibleNav : hiddenNav}
      id={navId}
      loggedIn={loggedIn}
      onLinkClick={onNavLinkClick}
      onCloseClick={onNavCloseClick}
      expanded={navVisible}
      transparent={transparent}
      onSearchLinkClick={onSearchLinkClick}
      profile={profile}
    />
    <div className={transparent ? transparentSearch : search} onClick={onSearchLinkClick} />
    {profile && (
      <Link to="/profile" className={hideAboveSM}>
        <Avatar user={profile} small />
      </Link>
    )}
  </div>
);

HeaderMenu.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean describing user autenticated state.
   */
  loggedIn: PropTypes.bool,
  /**
   * String ID for the nav component.
   */
  navId: PropTypes.string,
  /**
   * Boolean whether to show menu navigation.
   */
  navVisible: PropTypes.bool,
  /**
   * Function to call on menu button click.
   */
  onButtonClick: PropTypes.func,
  /**
   * Function to call on mask click.
   */
  onMaskClick: PropTypes.func,
  /**
   * Function to call on nav close click.
   */
  onNavCloseClick: PropTypes.func,
  /**
   * Function to call on nav link click.
   */
  onNavLinkClick: PropTypes.func,
  /**
   * Boolean whether to use transparent styles.
   */
  transparent: PropTypes.bool,
  /*
   * TODO.
   */
  onSearchLinkClick: PropTypes.func,
  /*
   * TODO.
   */
  onSearchCloseClick: PropTypes.func,
   /*
    * User public profile object.
    */
  profile: PropTypes.shape(),
   /*
    * TODO.
    */
  searchVisible: PropTypes.bool,
};

HeaderMenu.defaultProps = {
  className: '',
  loggedIn: false,
  navId: 'menuNav',
  navVisible: false,
  onButtonClick: () => {},
  onMaskClick: () => {},
  onNavCloseClick: () => {},
  onNavLinkClick: () => {},
  onSearchLinkClick: () => {},
  onSearchCloseClick: () => {},
  profile: undefined,
  searchVisible: false,
  transparent: false,
};

export default HeaderMenu;



// WEBPACK FOOTER //
// ./app/src/components/HeaderMenu/index.jsx